import { StudentFiltersEnum, TeacherFiltersEnum } from '../../constants';

export const activeFilterIsStudentFilter = (
  activeFilter: TeacherFiltersEnum | StudentFiltersEnum | undefined,
  page?: 'trajectory' | undefined
) => {
  if (activeFilter === undefined) return true;
  if (page === 'trajectory') return activeFilter === StudentFiltersEnum.PROGRESS_AND_SCORES;
  
  switch (activeFilter) {
    case StudentFiltersEnum.PROGRESS:
    case StudentFiltersEnum.SCORES:
    case StudentFiltersEnum.PROGRESS_AND_SCORES:
      return true;
    default:
      return false;
  }
};
